<template>
    <div style="height: 100%">
        <iframe
            :id="iframeId"
            :src="url"
            :title="name"
            frameBorder="0"
            :height="height"
            :width="width"
        />
        <oss-dialog v-model="dialogStatusSync" :title="name" max-width="60vw">
            <div style="height: 100%" class="d-flex justify-center">
                <iframe
                    :id="iframeId"
                    :src="url"
                    :title="name"
                    frameBorder="0"
                    height="600"
                    width="600"
                />
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    emits: ["close"],
})
export class OssWidgetEmbedder extends Vue {
    @Prop({ default: "" }) url;
    @Prop({ default: "" }) name;
    @Prop({ default: "iframe" }) id;
    @Prop({ default: "100%" }) height;
    @Prop({ default: "100%" }) width;

    @Model({ default: false, name: "dialogStatus" }) dialogStatusSync;

    fromIframe = null;

    get company() {
        return this.$store.state.selected_company;
    }

    get iframeId() {
        return `extension-${this.id}`;
    }

    beforeMount() {
        const iframe: any = document.getElementById(this.iframeId);
        if (iframe) {
            iframe.onload = () => {
                this.onCompanyChange();
            };
        }
        window.addEventListener("message", ({ data }) => {
            this.handleMessage(data);
        });
    }

    handleMessage(event: string) {
        if (event === "close-dialog") {
            this.$emit("close");
        }
    }

    @Watch("company", { deep: true })
    async onCompanyChange() {
        if (!this.iframeId) {
            return;
        }
        const iframe: any = document.getElementById(this.iframeId);
        if (!iframe || !iframe?.contentWindow || !iframe.contentWindow?.postMessage) {
            return;
        }
        // setTimeout(() => {
        //     if (iframe?.contentWindow?.postMessage) {
        //         try {
        //             iframe.contentWindow.postMessage(
        //                 {
        //                     type: "company",
        //                     payload: this.company,
        //                 },
        //                 "*",
        //             );
        //         } catch (e) {
        //             console.error("Error sending message to iframe:", e);
        //         }
        //     }
        // }, 500);
    }
}

export default toNative(OssWidgetEmbedder);
</script>